var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-photo" }, [
    _vm.uploadHeaders
      ? _c(
          "form",
          { ref: "photoForm", attrs: { method: "post" } },
          [
            _c("input", {
              key: _vm.timeStamp,
              ref: "popup-select-files",
              attrs: { type: "file", accept: "image/*", autocomplete: "off" },
              on: { change: _vm.addFile },
            }),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }